import tmhRequest from '@/config/tmhRequest'

export default {
    searchSaleItemReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/saleitemreport/searchsaleitemreportcount',
            method: 'post',
            data: data,
        })
    },
    searchSaleItemReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/saleitemreport/searchsaleitemreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportSaleItemReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/saleitemreport/exportsaleitemreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/saleitemreport.js